import { useState, useCallback, useRef } from "react";

/**
 * useSessionEndProposal
 * Handles AI propose_session_end function calls and triggers end-of-session logic.
 */
export default function useSessionEndProposal({ handleEndSession }) {
  const [endProposed, setEndProposed] = useState(null);
  const endTimerRef = useRef(null);

  const onEndProposed = useCallback(
    ({ reason = "", confidence = 0 }) => {
      console.log("[AI propose_session_end]", { reason, confidence });

      setEndProposed({ reason, confidence, ts: Date.now() });

      const CONFIDENCE_THRESHOLD = 0.6;

      clearTimeout(endTimerRef.current);

      if (confidence >= CONFIDENCE_THRESHOLD) {
        console.log(`[Auto End] Confidence ${confidence} ≥ ${CONFIDENCE_THRESHOLD}`);
        handleEndSession?.();
      } else {
        endTimerRef.current = setTimeout(() => {
          console.log(`[Auto End] Fallback triggered after low confidence (${confidence})`);
          handleEndSession?.();
        }, 1000);
      }
    },
    [handleEndSession]
  );

  return {
    endProposed,
    setEndProposed,
    onEndProposed, // ✅ direct callback
  };
}
